import { collection, CollectionReference, onSnapshot } from 'firebase/firestore';
import { firestore } from '~/firebase/init';
import { EnterpriseGroupBuyStore } from '~/types/enterpriseGroupBuy';

export function enterpriseGroupBuyStoresMapListener(
  enterpriseGroupBuyId: string,
  onNext: (dataMap: Map<string, EnterpriseGroupBuyStore>) => void,
) {
  const ref = collection(
    firestore,
    'enterpriseGroupBuy',
    enterpriseGroupBuyId,
    'stores',
  ) as CollectionReference<EnterpriseGroupBuyStore>;

  return onSnapshot(ref, {
    next: (snapShot) => {
      const storesMap = new Map((snapShot.docs || []).map((item) => [item.id, item.data() || {}]));
      onNext(storesMap);
    },
    error: () => {
      console.error(`listen enterpriseGroupBuy/${enterpriseGroupBuyId}/stores error`);
    },
  });
}
